<div class="flex flex-col pt-4 space-y-4">
  <app-section-header
    [title]="pageHeader"
    [isBackBtnShown]="true"
    [backRoute]="['/dashboard']"
    [preserveQueryParam]="true"
  >
    <app-content-state-controls
      *ngIf="initialDigitalPublicationContent"
      [allowableNextStates]="
        initialDigitalPublicationContent.dynamicData.allowableNextStates
      "
      [isProcessingStateChange]="isProcessingStateChange"
      [isPublished]="initialDigitalPublicationContent.isPublished()"
      [isSpiked]="initialDigitalPublicationContent.isSpiked"
      [form]="form"
      [isSaving]="isSaving"
      (handleStateChange)="onUpdateState($event)"
      (handleReEditClick)="onCreateNewVersion()"
      (handleReactivateClick)="onReactivate()"
    ></app-content-state-controls>
  </app-section-header>
  <ng-container *ngIf="isProcessing || initialDigitalPublicationContent">
    <app-processing-boundary
      [isProcessing]="isProcessing || !initialDigitalPublicationContent"
      [processingMsg]="'Loading...'"
    >
      <div *ngIf="initialDigitalPublicationContent">
        <app-content-status-card
          [form]="form"
          [formReady]="formReady.asObservable()"
          [content]="initialDigitalPublicationContent"
          [isSaving]="isSaving"
          [isLoading]="isLoading"
          (handleSave)="onSave()"
          class="px-4"
        ></app-content-status-card>
        <app-content-status-message
          [content]="initialDigitalPublicationContent"
          [contentType]="CONTENT_TYPES.DIGITAL_PUBLICATION"
        ></app-content-status-message>
      </div>
      <form
        class="flex p-4 space-x-4"
        (keydown.enter)="$event.preventDefault()"
        [formGroup]="form"
        *ngIf="initialDigitalPublicationContent"
      >
        <div class="flex flex-col flex-1 min-w-0 space-y-4">
          <app-text-input
            class="large-text"
            [control]="form.get(FORM_PATHS.HEADLINE())"
            [boldFont]="true"
            placeholder="Headline"
          ></app-text-input>
          <app-text-input
            [control]="form.get(FORM_PATHS.URL())"
            placeholder="Url"
          ></app-text-input>
          <app-auto-complete-with-add
            class="flex flex-col flex-grow-0"
            [control]="form.get(FORM_PATHS.PLATFORM())"
            [searchList]="platformsSearchResult"
            [exactMatch]="platformExactMatch"
            [isSearching]="isSearchingPlatforms"
            placeholder="Platform"
            addNewText="platform"
            (handleAddNew)="onAddNewPlatform($event)"
          ></app-auto-complete-with-add>
          <app-auto-complete-with-add
            class="flex flex-col flex-grow-0"
            [control]="form.get(FORM_PATHS.PRODUCT())"
            [searchList]="productsSearchResult"
            [exactMatch]="productExactMatch"
            [isSearching]="isSearchingProducts"
            placeholder="Product"
            addNewText="product"
            (handleAddNew)="onAddNewProduct($event)"
          ></app-auto-complete-with-add>
          <app-auto-complete-with-add
            class="flex flex-col flex-grow-0"
            [control]="form.get(FORM_PATHS.CLIENT())"
            [searchList]="clientsSearchResult"
            [exactMatch]="clientExactMatch"
            [isSearching]="isSearchingClients"
            placeholder="Client"
            addNewText="client"
            (handleAddNew)="onAddNewClient($event)"
          ></app-auto-complete-with-add>
          <app-digital-publication-section-list
            [sectionArray]="form.get(FORM_PATHS.SECTIONS())"
            [urlPath]="form.get(FORM_PATHS.URL())"
            [isDisabled]="!isEditMode"
          >
          </app-digital-publication-section-list>
        </div>
        <div class="flex flex-1 min-w-0 pt-1.5 mt-2">
          <mat-accordion [multi]="false" class="flex flex-1 space-x-3">
            <div class="flex flex-col w-1/2 min-w-0 space-y-3 basis-1/2">
              <app-related-data
                [isExpandable]="isEditMode"
                [isExpandedByDefault]="false"
                [isShowingSurtitles]="false"
                [managerListControl]="form.get(FORM_PATHS.RELATED_MANAGERS())"
                [fundListControl]="form.get(FORM_PATHS.RELATED_FUNDS())"
                [sectorListControl]="form.get(FORM_PATHS.RELATED_SECTORS())"
                [assetClassListControl]="
                  form.get(FORM_PATHS.RELATED_ASSET_CLASSES())
                "
                [etfListControl]="form.get(FORM_PATHS.RELATED_ETFS())"
                [investmentTrustListControl]="
                  form.get(FORM_PATHS.RELATED_INVESTMENT_TRUSTS())
                "
                [shareListControl]="form.get(FORM_PATHS.RELATED_SHARES())"
              ></app-related-data>
              <app-tagging
                [topicControl]="form.get(FORM_PATHS.TOPICS())"
                [tagControl]="form.get(FORM_PATHS.TAGS())"
                [companyControl]="form.get(FORM_PATHS.COMPANIES())"
                [peopleControl]="form.get(FORM_PATHS.PEOPLE())"
                [websites]="[]"
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
                [isShowingSurtitles]="false"
              >
              </app-tagging>
            </div>
            <div class="flex flex-col w-1/2 min-w-0 space-y-3 basis-1/2">
              <app-publish-time
                [publishTimeControl]="form.get(FORM_PATHS.PUBLISH_TIME())"
                [timezoneControl]="form.get(FORM_PATHS.TIMEZONE())"
                [showPublishTimeControl]="
                  form.get(FORM_PATHS.SHOW_PUBLISH_TIME())
                "
                [isExpandedByDefault]="true"
                [isExpandable]="isEditMode"
                [timezones]="timezones"
                [enableAutomatic]="false"
              ></app-publish-time>
              <app-authors
                id="formSectionAuthors"
                data-testid="formSectionAuthors"
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
                [selectedAuthors]="form.get(FORM_PATHS.SELECTED_AUTHORS())"
                [searchedAuthor]="searchedAuthor"
                [authorList]="authorList"
                [searchList]="searchList"
              ></app-authors>
              <app-internal-information
                [urls]="initialDigitalPublicationContent.dynamicData.liveUrls"
                [contentId]="initialDigitalPublicationContent.contentId"
                [isExpandedByDefault]="false"
              ></app-internal-information>
              <app-version-list
                [versions]="
                  initialDigitalPublicationContent.dynamicData.versions
                "
                [articleId]="initialDigitalPublicationContent.id"
                [latestPublishedVersionId]="
                  initialDigitalPublicationContent.dynamicData
                    .latestPublishedVersionId
                "
                [latestVersionId]="
                  initialDigitalPublicationContent.dynamicData.latestVersionId
                "
                [isExpandedByDefault]="false"
                [contentType]="CONTENT_TYPES.DIGITAL_PUBLICATION"
              ></app-version-list>
              <button
                mat-button
                type="button"
                class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
                *ngIf="
                  !initialDigitalPublicationContent.isPublished() &&
                  initialDigitalPublicationContent.dynamicData.versions.length >
                    1
                "
                (click)="deleteUnpublishedDraft()"
                [disabled]="isProcessingStateChange || isSaving"
                mat-raised-button
                data-testid="deleteUnpublishedButton"
              >
                Delete Unpublished Draft
              </button>
              <button
                mat-button
                type="button"
                class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
                *ngIf="!isNewArticle"
                (click)="onDelete()"
                [disabled]="isProcessingStateChange || isSaving"
                mat-raised-button
                data-testid="deleteButton"
              >
                Delete content
              </button>
            </div>
          </mat-accordion>
        </div>
      </form>
    </app-processing-boundary>
  </ng-container>
</div>
